import React from 'react';
import { Box, IconButton } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Styled } from './dialog.styled';
import { statusColors } from '../../utils/utils';

const DialogHeader: React.FC<any> = ({ onClose, label, icon, type }) => {
    return (
        <Styled.Toolbar>
            <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                {icon && (
                    <Styled.Icon sx={{ ...statusColors[type] }}>
                        {icon}
                    </Styled.Icon>
                )}

                {label && (
                    <Styled.Label variant="h6">
                        {label}
                    </Styled.Label>
                )}
            </Box>

            <IconButton
                edge="start"
                color="inherit"
                onClick={onClose}
                sx={(theme) => ({
                    width: 36,
                    height: 36,
                    flexShrink: 0,
                    color: 'text.secondary',
                    border: '1px solid',
                    borderColor: 'border.light',
                    backgroundColor: alpha(theme.palette.background.extraLight ?? theme.palette.background.paper, 0.72),
                    '&:hover': {
                        color: 'text.primary',
                        backgroundColor: 'action.hover',
                    },
                })}
            >
                <i className="fa-light fa-xmark" />
            </IconButton>
        </Styled.Toolbar>
    );
};

export default DialogHeader;
